import ValidityOption from './validity_option';

export default ValidityOption;
